<!--
  FE-201 — `floatLabel="always"` is what makes the placeholder visible at rest.

  Single-house mode is the only branch of `ui-insurables` with no
  `.section-title` above its field, and the reskin visually CLIPS Material's own
  floating label inside `ui-insurables` precisely because everywhere else that
  label duplicates the section title (see the `ui-insurables` block in
  assets/styles/components/pma-flow/index.scss). Here there is no title to
  duplicate, so clipping the label left the box showing nothing but the home
  icon.

  The placeholder could not fill the gap because MDC blanks it whenever a label
  exists and is not floating — `.mdc-text-field__input::placeholder{opacity:0}`,
  lifted only by `--focused` or by `.mat-mdc-form-field-label-always-float`.
  That is the whole reason text appeared on click and not before.

  Always-float sets that class, so the placeholder shows immediately; the label
  itself stays clipped and keeps providing the accessible name, which a
  placeholder cannot be relied on to do. Scoped by construction — this template
  renders only when `pma_single_houses_mode` is on.
-->
<mat-form-field fxFlex="100%" appearance="outline" floatLabel="always">
  <mat-label>Address</mat-label>
  <div matPrefix style="margin: 8px">
    <mat-icon>home</mat-icon>
  </div>
  <input type="text" required [formControl]="addressControl" [matAutocomplete]="autoInsurable" matInput placeholder="Please start typing address...">
  <mat-autocomplete autoActiveFirstOption #autoInsurable="matAutocomplete" [displayWith]="displayFnAddress">
    <mat-option *ngFor="let address of addresses" [value]="address">
      <span class="caption">{{ getAddress(address) }}</span>
    </mat-option>
  </mat-autocomplete>
  <button *ngIf="loader" class="text-secondary spinner" mat-icon-button matSuffix type="button">
    <mat-icon>loading</mat-icon>
  </button>
  <button *ngIf="!loader && addressControl.value && addressControl.enabled" mat-icon-button matSuffix (click)="reset()" type="button">
    <mat-icon>close</mat-icon>
  </button>
  <button *ngIf="!loader && !addressControl.value && addressControl.enabled" class="text-secondary" mat-icon-button matSuffix type="button">
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-hint>{{ notFound ? 'No results found. Please try changing your search query' : '' }}</mat-hint>
  <mat-error *ngIf="addressControl.invalid">{{ addressControl | errorMsg:'Address' }}</mat-error>
</mat-form-field>
